export default __webpack_public_path__ + "1ac9a26e121c116626015e02c7f8335e.svg";